import { mapAirportToCity } from '~touchpoints/AccommodationRecommendations/utils/mapAirportToCity';
import type { CheckoutSegment } from '../../../types';
import {
  getCheckinDateFromSegments,
  getCheckoutDateForOneWayTripFromSegments,
  getCheckoutDateForRoundTripFromSegments,
} from '~utils/tripUtils';
import { formatForHsaResultsPage } from '~utils/dateUtils';

const getAccommodationInfoFromFlight = ({
  segments,
  isMultiDestination,
  isRoundTrip,
}: {
  segments: CheckoutSegment[];
  isMultiDestination: boolean;
  isRoundTrip: boolean;
}) => {
  const [firstSegment] = segments;
  const geoNodeId = mapAirportToCity(parseInt(firstSegment.destination.id)).id;

  const checkInDate = getCheckinDateFromSegments(segments);
  const isOneWayTrip = !isMultiDestination && !isRoundTrip;
  const checkOutDate = isOneWayTrip
    ? getCheckoutDateForOneWayTripFromSegments(segments)
    : getCheckoutDateForRoundTripFromSegments(segments);

  return {
    checkInDate: checkInDate ? formatForHsaResultsPage(checkInDate) : null,
    checkOutDate: checkOutDate ? formatForHsaResultsPage(checkOutDate) : null,
    geoNodeId,
  };
};

export default getAccommodationInfoFromFlight;
